import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { ActionButton } from '@/model/button';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionButtons',
  props: {
    actions: {},
    mode: {},
    placement: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (button, index) => {
    return (_openBlock(), _createBlock(_component_a_tooltip, {
      key: index,
      placement: _ctx.placement ? _ctx.placement(index) : 'top'
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(button.tooltip), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: _normalizeClass(["rounded-md", (_ctx.mode === button.mode ? button.activeClass : button.hoverClass) + ' border-none']),
          onClick: ($event: any) => (button.action())
        }, {
          icon: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(button.component), _normalizeProps(_guardReactiveProps({ ...button.props })), null, 16))
          ]),
          _: 2
        }, 1032, ["onClick", "class"])
      ]),
      _: 2
    }, 1032, ["placement"]))
  }), 128))
}
}

})